import Vue from 'vue'
import api from 'api'
import storage from 'src/unit/storage'
import config from 'common/config'
import { conver } from 'common/msgConver'
import { checkAcls, checkRole, checkProjectAcls } from 'common/acl'
import store from 'store'

function getWinOptions(arg = []) {
    let isOpt = typeof arg[0] === 'object'
    let options = isOpt ? arg[0] : typeof arg[1] === 'object' ? arg[1] : arg[2] || {}
    let defOpts = {
        title: typeof arg[1] === 'string' ? arg[1] : '',
        content: !isOpt ? arg[0] : ''
    }
    return { ...defOpts, ...options }
}

export default class Base extends Vue {
    api = api
    config = config
    imgList = []
    idIndex = 0
    idList = []
    // 当前环境env: production,sit,development
    env = process.env.NODE_ENV

    // 项目类型枚举
    projectTypeEnum = {
        project: '工程',
        maintenance: '维保',
        sale: '销售',
        service: '服务',
        detection: '检测',
        maint_det: '维检'
    }

    // 页面跳转
    goTo(options) {
        this.$router.push(options)
    }

    /**
     * 权限判断
     * @param {string[]} acls     权限对象
     * @returns {Boolean}
     */
    checkAcls(acls = {}, hasProjectAcl = false) {
        return checkAcls(acls, hasProjectAcl)
    }

    // 项目动态权限判断
    checkProjectAcls(acls = {}) {
        return checkProjectAcls(acls)
    }

    // 角色判断
    checkRole(role = []) {
        return checkRole(role)
    }

    // 获取项目动态权限
    getProjectAcls() {
        return localStorage.getItem('projectAcls') ? JSON.parse(localStorage.getItem('projectAcls')) : null
    }

    // 设置项目动态权限
    setProjectAcls(data) {
        if (!data || JSON.stringify(data) === '{}') {
            localStorage.removeItem('projectAcls')
        } else {
            localStorage.setItem('projectAcls', JSON.stringify(data))
        }
    }

    /**
     * 显示全局loading
     * @param {string} text     文字内容
     * @param {object} options  选项（非必填）
     */
    showLoading(text = '', options) {
        let defOpts = {
            text: text,
            show: true,
            position: 'absolute', // absolute | fixed
            transition: 'vux-mask'
        }
        this.$vux.loading.show({ ...defOpts, ...options })
    }

    /**
     * 隐藏全局loading
     */
    hideLoading() {
        this.$vux.loading.hide()
    }

    // 监听loading状态(仅用于 Vue 的 Watch)
    checkLoading(loading) {
        if (typeof loading === 'boolean') {
            if (loading) {
                this.showLoading()
            } else {
                this.hideLoading()
            }
        }
    }

    /**
     * 全局toast
     * @param {string} text     文字内容
     * @param {object} options  选项（非必填）
     */
    toast(text = '', options) {
        if (typeof text === 'object') return

        let defOpts = {
            text: text,
            type: 'text',        // success | warn | cancel | text
            time: 2000,
            width: '10em',
            position: 'default', // default | top | middle | bottom
            isShowMask: false
        }
        this.$vux.toast.show({ ...defOpts, ...options })
    }

    /**
     * 封装 alert 方法
     * @param {string} content  文字内容
     * @param {string} title    标题（非必填）
     * @param {object} options  选项（非必填）
     * @example this.alert('内容')
     *          this.alert('内容', '标题')
     *          this.alert('内容', {
     *              onShow() {
     *                  ...
     *              }
     *          })
     */
    alert() {
        let opts = getWinOptions(arguments)
        this.$vux.alert.show(opts)
    }

    /**
     * 封装 comfirm 方法
     * @param {string} content  文字内容
     * @param {string} title    标题（非必填）
     * @param {object} options  选项（非必填）
     * @example this.comfirm({
                    content: '是否立即创建？',
                    title: '提示',
                    onConfirm () {},
                    onCancel () {}
                })
     */
    comfirm() {
        let opts = getWinOptions(arguments)
        this.$vux.confirm.show(opts)
    }

    /**
     * sleep 定时器
     * @param {number} time 毫秒
     * @returns {Promise}
     */
    sleep(time = 0, num) {
        return new Promise((resolve) => {
            let timeId = setTimeout(function () {
                resolve(timeId)
            }, time)
        })
    }

    /**
     * 将 map 转换成 select 选项
     * @param {*} obj
     */
    mapToOptions(obj) {
        let res = []
        Object.keys(obj).forEach((key) => {
            res.push({
                value: String(key),
                name: obj[key]
            })
        })
        return res
    }

    /**
     * 将 数字字典[{code:'', name: '', actice: true}]格式 转换成 select 选项
     * or将 数字字典[{id:'', name: '', actice: true}]格式 转换成 select 选项
     * @param {*} arr
     */
    dictToOptions(arr = []) {
        let res = [[{name: '', value: ''}]]
        for (let i = 0; i < arr.length; i++) {
            // if (item.active === true) {}
            res[0].push({
                value: i, // 选择是返回角标，具体数据根据角标去获取
                name: arr[i].name
            })
        }
        return res
    }

    /**
     * 遍历 类数字字典[{id:'',code:'', name: '', actice: true}] 获取id/code/name的数组集合
     * @param {*} arr: []
     * @param {*} type: 'id','code','name'
     */
    getDictValueByKey(arr = [], type) {
        // let idArr = []
        // let codeArr = []
        // let nameArr = []
        let typeObj = {
            id: [],
            code: [],
            name: []
        }
        if (!typeObj[type]) {
            alert('参数有误')
            return
        }
        for (let i = 0; i < arr.length; i++) {
            typeObj[type].push(arr[i][type])
            // idArr.push(arr[i].id)
            // codeArr.push(arr[i].code)
            // nameArr.push(arr[i].name)
        }
        return typeObj[type]
    }

    /**
     * 获取问候语(早上好、中午好...)
     * @param {date} date
     * @returns string
     */
    getGreet(date) {
        if (!date || new Date(date) === 'Invalid Date') {
            date = storage.get('callTime') || new Date()
        }
        let hours = new Date(date.replace(/-/g, '/')).getHours()
        let greet = config.greet
        let text = ''
        for (let e in greet) {
            if (hours < e) {
                text = greet[e]
                break
            }
        }
        return text
    }

    /**
     * 自动拼接消息内容
     * @param {object} msgInfo  消息拼接字段
     * @param {string} typeName  消息模版类型
     * @param typeName:
     *     business_manager：商务经理
     *     maintain_principal：维保负责人
     *     supervisor：工程公司
     *     admin：管理员
     *     project：项目关键动态（仅针对项目的消息）
     */
    converMsg(msgInfo, typeName) {
        return conver(msgInfo, typeName)
    }

    // 获取微信api信息
    async getWXConfig() {
        if (!this.isWX()) {
            return
        }
        try {
            let data = await this.api.common.getWXConfig()
            this.initWX(data)
        } catch (error) {
            this.hideLoading()
        }
    }

    /**
     * 初始化微信jsApi
     */
    initWX(res) {
        wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: ['chooseImage', 'uploadImage'] // 功能列表，我们要使用JS-SDK的什么功能
        })
    }

    /**
     * 微信选择图片
     */
    wxChooseImage(count = 1, callback) {
        this.imgList = []
        this.idIndex = 0
        this.idList = []
        let that = this
        wx.chooseImage({
            count: count > 9 ? 9 : count, // 还能上传的最大数量
            sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: function(res) {
                that.imgList = res.localIds
                that.wxUploadImg(callback)
            },
            fail: function(err) {
                that.toast('上传失败')
            }
        })
    }
    /**
     * 微信上传图片
     */
    wxUploadImg(callback) {
        let that = this
        wx.uploadImage({
            localId: that.imgList[that.idIndex], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function(data) {
                that.idList[that.idIndex] = data.serverId
                that.idIndex++
                if (that.idIndex < that.imgList.length) {
                    setTimeout(() => {
                        that.wxUploadImg(callback)
                    }, 50)
                } else {
                    callback(that.idList)
                }
            }
        })
    }

    // 判断是否为微信内置浏览器
    isWX() {
        var agent = navigator.userAgent.toLowerCase()
        if (agent.match(/MicroMessenger/i) && (agent.match(/MicroMessenger/i) === 'micromessenger' || agent.match(/MicroMessenger/i)[0] === 'micromessenger')) {
            return true
        } else {
            return false
        }
    }

    plusSelect(callback) {
        let that = this
        plus.nativeUI.actionSheet({title: '选择方式', cancel: '取消', buttons: [{title: '拍照', color: '#3c78fd'}, {title: '选择图片', color: '#3c78fd'}, {title: '选择文件', color: '#3c78fd'}]}, function(e) {
            if (e.index === 1) {
                that.appendByCamera(callback)
            } else if (e.index === 2) {
                that.appendByGallery(callback)
            } else if (e.index === 3) {
                alert('文件')
            }
        })
    }

    // 拍照添加文件
    appendByCamera(callback) {
        plus.camera.getCamera().captureImage(function(url) {
            callback(url)
        })
    }

    // 从相册添加文件
    appendByGallery(callback) {
        plus.gallery.pick(
            function(path) {
                callback(path)
            },
            function(e) {
                if (e.code === 8) {
                    if (plus.os.name === 'iOS') {
                        this.toast('没有访问相册权限,请到手机设置->隐私->相册,开启权限')
                    } else {
                        this.toast(e.message)
                    }
                }
            },
            { filter: 'none' }
        )
    }

    plusUpload(path) {
        let task = plus.uploader.createUpload(config.api.host + '/upload/plusUploadFile/' + storage.get('token'), {
            method: 'POST',
            blocksize: 2004800,
            priority: 100
        },
        function(t, status) {
            alert(status)
            alert(JSON.stringify(t))
            // 上传完成
            if (status === 200) {
                // var data = JSON.parse(t.responseText)
                // var data = JSON.parse(t.responseText)
                plus.nativeUI.alert('上传成功')
            } else {
                plus.nativeUI.alert('上传失败，请重试！')
            }
        })

        task.addFile(path, {
            key: 'image'
        })
        task.start()
    }

    /**
     * 手机号验证
     * @param {*} mobile
     */
    checkPhone(mobile) {
        let reg = /^1[0-9][0-9]{9}$/
        if (mobile && reg.test(mobile.trim())) {
            return true
        } else {
            return false
        }
    }

    /**
     * 身份证号验证
     * @param {*} idcardNum
     */
    checkIdcardNum(idcardNum) {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (idcardNum && reg.test(idcardNum.trim())) {
            return true
        } else {
            return false
        }
    }

    /**
     * 填充零
     * @param {*} num：当前数字or字符串
     * @param {*} targetLenght：目标长度
     */
    fillingZero(num, targetLenght) {
        if (!num || !targetLenght || targetLenght < 1) {
            return num
        }
        let n = targetLenght - ('' + num).length
        for (let i = 0; i < n; i++) {
            num = '0' + num
        }
        return num
    }

    // app环境下：在登录页和首页mounted内调用，plus已经在app.js初始化，
    checkVersion() {
        let newVersion = '1.1.0' // 版本号是在app重新发版修改（当app名字，图标，启动页修改时才需要重新打包）
        if (plus.runtime.version !== newVersion) {
            let that = this
            this.$vux.confirm.show({
                onCancel () {
                    plus.runtime.quit()
                },
                onConfirm () {
                    window.location.href = 'https://' + window.location.host + '#/ems/appDownload'
                },
                title: '版本更新',
                content: '您当前版本过低，请下载更新'
            })
        }
    }

    /**
     * 临时处理实名认证（处理目前数据有问题情况2019-04-23）
     * 判断当前用户是否只是项目人员角色，而没有其他角色
     * return: 有其他角色返回false, 否则true
     */
    onlyMaintainStaff() {
        let acls = [
            'business_manager_permission',
            'supervisor_permission',
            'inspector_permission',
            'info_manager_permission',
            'company_manager_permission',
            'project_manager',
            'vice_manager',
            'security_officer',
            'inspector',
            'construction_crew',
            'material_handler',
            'data_clerk',
            'weibao_technician',
            'weibao_project_manager',
            'engineering_manager'
        ]
        return !this.checkAcls(acls)
    }

    /**
     * 将图片数组的子项string转成object
     * @param {*} arr url数组
     * @param {*} type 文件目录标志
     */
    stringTurnToObject(arr = [], type) {
        let imgList = []
        arr.forEach(item => {
            if (item) {
                let imgItem = {
                    fp: item,
                    type: type,
                    name: item.split(type + '_')[1] || item.split('_')[1] || '',
                    ext: 'jpg'
                }
                imgList.push(imgItem)
            }
        })
        return imgList
    }

    // 通过id获取文件地址
    getFileUrl(id) {
        return this.config.api.host + '/file/attachment?id=' + id // java源
        // return this.config.api.pythonHost + '/attachment/' + id // python源
    }

    // 获取文件数组里面id
    getFileIdArr(arr) {
        let ids = []
        arr.forEach(item => {
            if (item.file_id) {
                ids.push(item.file_id)
            }
        })
        return ids
    }

    // 通过文件名获取文件的类型
    getFileType(name = '') {
        let nameArr = name.split('.')
        let fileType = nameArr[nameArr.length - 1]
        fileType = fileType.toLocaleLowerCase()
        if ('png/jpg/jpeg/bmp'.indexOf(fileType) !== -1) {
            return 'image'
        } else if ('doc/docx'.indexOf(fileType) !== -1) {
            return 'doc'
        } else if ('xls/xlsx'.indexOf(fileType) !== -1) {
            return 'xls'
        } else if (fileType === 'pdf') {
            return 'pdf'
        } else {
            return 'other'
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/base.js